import React from 'react'
import '../css/main_style.css';
import '../css/index.css';
import MenuBar from '../pages/Menu'
import Toppart from '../pages/toppart'
import IncomeIssue from '../pages/incomeissue'
import Footer from '../pages/Footer'

export default function IncomeFail() {
	return(		
		<div id="maincontainer">	
			<Toppart />
			<MenuBar />
			<IncomeIssue />
			<Footer />	
		</div>	
	)
}
		